import { observer } from 'mobx-react-lite'
import { useStore } from '@/store/index'
import useLangPrefix from '@/hooks/useLangPrefix'
import { Announcement } from '@gate/gui'
import { PriceDynamicStyled } from './style'
import { eventTracker } from '@/utils/collectEvent'
const PriceDynamic = () => {
  const { communityNews } = useStore().baseStore

  const { langPrefix } = useLangPrefix()

  return (
    <>
      {communityNews?.length ? (
        <Announcement
          messages={communityNews?.map(item => (
            <PriceDynamicStyled
              href={`${langPrefix}/post/status/${item?.id}`}
              target="_blank"
              className="size-16 font-500 text-2"
              key={item?.id}
              onClick={() => {
                eventTracker('price_overview_click', {
                  post_url: `${langPrefix}/post/status/${item?.id}`,
                })
              }}
            >
              {item?.title}
            </PriceDynamicStyled>
          ))}
          showNum={1}
          rightSectionOnClick={() => {
            eventTracker('price_overview_click', {
              button_name: 'post_more',
            })
            window.open(`${langPrefix}/profile/CxVFXFBYAQEBBScGGQQAAx5QX1sO0O0O`, '_blank')
          }}
        />
      ) : null}
    </>
  )
}

export default observer(PriceDynamic)
